<template>
  <div class="offcanvas-body">
    <TextInput
      required
      label="Formação"
      :model="educationModel"
      placeholder="Qual sua formação?"
    />
    <TextInput
      required
      label="Anos de experiência"
      :model="yearsExpModel"
      placeholder="Você trabalha há quantos anos na área?"
    />
    <TextInput
      required
      label="CRP"
      :model="crpModel"
      mask="##/######"
      placeholder="00/000000"
    />
    <TextInput
      label="E-psi"
      :model="epsiModel"
      placeholder="Qual número do seu E-psi?"
    />
    <TextAreaInput
      required
      label="Resumo do currículo"
      :model="bioModel"
      placeholder="Descreva um pouco sobre sua experiencia"
    />
  </div>

  <div class="offcanvas-footer">
    <FormButton
      :marginVertical="false"
      label="Concluir"
      :loading="submitting"
      @onClick="submit"
      :disabled="!meta.valid"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import { toTypedSchema } from "@vee-validate/zod";
import { useForm } from "vee-validate";
import { useVeeField } from "@/composables/useVeeField";
import { profileAboutSchema } from "@/schemas/profile";
import { useSessionStore } from "@/store/useSessionStore";
import { EventBus, EventBusNames } from "@/utils/EventBus";
import { useUpdateUser } from "@/composables/useAuth";

const sessionStore = useSessionStore();
const session = computed(() => sessionStore.session);
const submitting = ref(false);

const { handleSubmit, meta, resetForm } = useForm({
  validationSchema: toTypedSchema(profileAboutSchema),
  initialValues: {
    education: "",
    years_exp: "",
    crp: "",
    epsi: "",
    bio: "",
  },
});

const educationModel = useVeeField("education");
const yearsExpModel = useVeeField("years_exp");
const crpModel = useVeeField("crp");
const epsiModel = useVeeField("epsi");
const bioModel = useVeeField("bio");

onMounted(() => {
  if (session.value) {
    resetForm({
      values: {
        education: session.value.education ?? "",
        years_exp: String(session.value.years_exp ?? ""),
        crp: session.value.crp ?? "",
        epsi: (session.value as any).epsi ?? "",
        bio: session.value.bio ?? "",
      },
    });
  }
});

const { mutateAsync: updateUser } = useUpdateUser();

const submit = handleSubmit(async (values) => {
  try {
    submitting.value = true;
    await updateUser({ id: session.value!.id, ...values });
    EventBus.$emit(EventBusNames.SHOW_TOAST, {
      title: "Alterações feitas",
      msg: "Suas informações foram salvas",
    });
  } catch (error) {
    console.error(error);
  } finally {
    submitting.value = false;
  }
});
</script>
